export enum EntityListEventTypes {
	EntitySelected = 'entityselected'
}
